import React, { useEffect } from "react";
import {Route,useLocation } from "react-router-dom";

const  CustomRoute = ({ path, layout: Layout, page: Page }) => {
  const location = useLocation();

  useEffect(() => {
    scrollToTop();
  }, [path, location.pathname]);

  const scrollToTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  return (
    <Route path={path}>
      <Layout>
        <Page subdomain=""/>
      </Layout>
    </Route>
  );
};

export default CustomRoute;